import { jsx as _jsx } from "jsx-dom/jsx-runtime";
/** @jsxImportSource jsx-dom */
import { Loader } from "../Loader";
export var LoadingModalContent = function () {
    return (_jsx("div", { class: "p-16", children: _jsx(Loader, {}) }));
};
